import React from 'react';
import TablaSolicitudPanteon from './Tablas/TablaSolicitudPanteon';
import GraficoSolicitudPanteon from './Graficos/GraficoSolicitudPanteon';
import SolicitudPanteon from './Ventanas/SolicitudPanteon';
import { VStack, Heading } from '@chakra-ui/react';
import ObrasPanteonDashboard from './Dashboard/ObrasPanteonDashboard';

const ObrasPanteon: React.FC = () => {
  return (
    <VStack spacing={8} align="stretch">
      <Heading size="lg" textAlign="center" color="blue.700">
        Panteon
      </Heading>
      <ObrasPanteonDashboard/>
      <TablaSolicitudPanteon />
      {/* <GraficoSolicitudPanteon /> */}
    </VStack>
  );
};

export default ObrasPanteon;
